import { Storage } from '@service/storage';
import { Events, pubsub } from '@service/pubsub';
import { BranchLocation } from '@model/branch-location';
import logger from '@service/logger';
import initializer from '@service/initializer';

// ZIP Code Header Management
export class HeaderZipCodeSelector extends HTMLElement {
  storage = Storage.sessionForKey('locationInformation');

  /**
   * @type {HTMLElement}
   */
  zipDisplay;

  /** @type {boolean} */
  hasLocationInformation = false;

  /**
   * @type {HTMLElement}
   */
  zipCollector;

  async init() {
    // Listen for events that say a ZIP code was collected.
    // Our component will need to update itself when a new value appears.
    pubsub.sub(Events.zipCodeResolved, zipCodeData => {
      sessionStorage.setItem('customerZipCode', zipCodeData.zip);
      this.updateZipCodeDisplay(zipCodeData);
    });

    // Handle trigger click (show modal)
    this.zipCollector.addEventListener('click', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      pubsub.publish(Events.raiseZipCodeModal);
    });

    // Handle display click (allow changing zip code)
    if (this.zipDisplay) {
      this.zipDisplay.addEventListener('click', () => {
        pubsub.publish(Events.raiseZipCodeModal);
      });
    }

    // Is there anything in storage already?
    const storedZip = this.getStoredLocationInformation();
    if (!!storedZip) {
      const data = Object.assign(new BranchLocation(), JSON.parse(storedZip));
      if (5 === data?.zip?.length) {
        this.hasLocationInformation = true;
        this.updateZipCodeDisplay(data);
      } else {
        this.hasLocationInformation = false;
        this.updateZipCodeDisplay(null);
      }
    } else {
      this.updateZipCodeDisplay(null);
    }

    if (!this.hasLocationInformation) {
        const maxMindScriptURL = 'https://geoip-js.com/js/apis/geoip2/v2.1/geoip2.js';
     
        let maxMindScript = document.createElement('script');
            maxMindScript.type = 'text/javascript';
            maxMindScript.id = 'maxMindScript';
            maxMindScript.src = maxMindScriptURL;

        logger.log('hasLocationInformation is false - using MaxMind ('+maxMindScriptURL+') to autofill zip code field...');

        document.head.appendChild(maxMindScript);
     
        document.getElementById('maxMindScript').addEventListener('load', function() {
          if (!sessionStorage.getItem('locationInformation')) { // fallback
            geoip2.city(function(result) {

              logger.log('MaxMind zip returned: '+result.postal.code);

              document.getElementById('zipcode-modal-entry-input').value = result.postal.code;

              let submitBtn =  document.querySelector('[data-submit-zipcode]');
              setTimeout(() => {
                submitBtn.click();
              }, 150); // race defense + trigger default submit

            });
          }
        });
    } else {
      logger.log('hasLocationInformation - no need to call MaxMind');
    }

  }

  constructor() {
    super();
    this.zipDisplay = this.querySelector('.zip-code-display');
    this.zipCollector = this.querySelector('.zip-code-collector');
    if (!this.zipDisplay || !this.zipCollector) {
      return;
    }

    this.init().then(() => {});
  }

  /**
   * Update the ZIP code display in the header
   * @param {ZipCode} zipCodeData
   */
  updateZipCodeDisplay(zipCodeData) {
    if (!zipCodeData) {
      this.zipDisplay.classList.add('hidden');
      this.zipCollector.classList.remove('hidden');
      return;
    }

    if (5 === zipCodeData?.zip?.length) {
      // Show the zip code display, hide the trigger
      this.zipCollector.classList.add('hidden');

      // show
      this.zipDisplay.innerHTML = zipCodeData.zip;
      this.zipDisplay.classList.remove('hidden');
    }
  }

  getStoredLocationInformation() {
    return (
      sessionStorage.getItem('locationInformation') || localStorage.getItem('locationInformation')
    );
  }

  isValidZipCode(zipCode) {
    return zipCode && /^\d{5}$/.test(zipCode);
  }

  static register() {
    if (!customElements.get('header-zip-code-selector')) {
      customElements.define('header-zip-code-selector', HeaderZipCodeSelector);
    }
  }
}

HeaderZipCodeSelector.register();
